import React, { useEffect, useState } from 'react';

const PopupNotification = ({ 
  message, 
  isVisible, 
  onClose, 
  requireAgreement = false, 
  agreementText = '', 
  onAccept 
}) => {
  const [isAgreed, setIsAgreed] = useState(false);

  useEffect(() => {
    if (isVisible) {
      // Prevent body scroll when popup is open
      document.body.style.overflow = 'hidden';
      // Reset agreement state when popup opens
      setIsAgreed(false);

      return () => {
        document.body.style.overflow = 'unset';
      };
    }
  }, [isVisible]);

  if (!isVisible) return null;

  const handleOkClick = () => {
    if (requireAgreement && onAccept) {
      onAccept();
    } else {
      onClose();
    }
  };

  const handleOverlayClick = requireAgreement ? undefined : onClose;

  return (
    <div className="wwoof-popup-overlay" onClick={handleOverlayClick}>
      <div className="wwoof-popup" onClick={(e) => e.stopPropagation()}>
        <div className="wwoof-popup-content">
          <div 
            className="wwoof-popup-message"
            dangerouslySetInnerHTML={{ __html: message }}
          />
          
          {requireAgreement && (
            <div className="wwoof-popup-agreement">
              <label className="wwoof-popup-agreement-label">
                <input
                  type="checkbox"
                  checked={isAgreed}
                  onChange={(e) => setIsAgreed(e.target.checked)}
                  className="wwoof-popup-agreement-checkbox"
                />
                <span className="wwoof-popup-agreement-text">
                  {agreementText}
                </span>
              </label>
            </div>
          )}
          
          <div className="wwoof-popup-buttons">
            {requireAgreement && (
              <button 
                className="wwoof-popup-cancel" 
                onClick={onClose}
              >
                Cancel
              </button>
            )}
            <button 
              className="wwoof-popup-close" 
              onClick={handleOkClick}
              disabled={requireAgreement && !isAgreed}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupNotification;
